import { useEffect, useState } from "react";
import { API_URL } from "../config";

export const useApproveImages = ({ page, limit, filters, refreshKey }) => {
  const [images, setImages] = useState([]);
  const [imagesCount, setImagesCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = new URL(`${API_URL}/api/approve/images`);
    url.searchParams.append("page", page);
    url.searchParams.append("limit", limit);
    url.searchParams.append("status", "preapproved");

    const labelId = filters.labels?.[0];
    const promptId = filters.prompts?.[0];
    if (typeof labelId === "number") url.searchParams.append("id_label", labelId);
    if (typeof promptId === "number") url.searchParams.append("id_prompt", promptId);

    setLoading(true);
    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => { setImages(data); setLoading(false); })
      .catch((err) => { console.error("Error fetching approve images:", err); setLoading(false); });
  }, [page, limit, filters, refreshKey]);

  useEffect(() => {
    const url = new URL(`${API_URL}/api/approve/images_count`);
    url.searchParams.append("status", "preapproved");

    const labelId = filters.labels?.[0];
    const promptId = filters.prompts?.[0];
    if (typeof labelId === "number") url.searchParams.append("id_label", labelId);
    if (typeof promptId === "number") url.searchParams.append("id_prompt", promptId);

    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => setImagesCount(data.count || 0))
      .catch((err) => console.error("Error fetching approve image count:", err));
  }, [filters, refreshKey]);

  return { images, imagesCount, loading };
};
